import { Suspense } from "react";

import AppDialog from "components/AppDialog";
import BullhornMetadata from "components/BullhornMetadata";
import SkeletonTables from "components/SkeletonTables";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import { getUserName } from "utils/helpers/users";

import ActivityHistory from "./components/ActivityHistory";
import FreelancerPitch from "./components/FreelancerPitch";
import MatchHistory from "./components/MatchHistory";
import MatchMetadata from "./components/MatchMetadata";

export default function UserInfoModal({
  open,
  onOpenChange,
  onClose,
  match = {},
  user,
  tabDefaultValue,
}) {
  const { applicationId, freelancerPitch, jobOpportunityId } = match;
  const hasMatch = !!(applicationId && jobOpportunityId);
  const defaultTab =
    tabDefaultValue || (hasMatch ? "freelancer-pitch" : "activity-history");

  const { id } = user;
  const displayName = getUserName(user) || user.username;

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      onClose={onClose}
      header={`User: ${displayName}`}
      className="flex h-[92vh] max-h-[92vh] w-[92vw] max-w-[1200px] flex-col overflow-hidden rounded-lg"
      contentClassName="px-6 pb-6 pt-4"
    >
      <Tabs
        activationMode="manual"
        defaultValue={defaultTab}
        className="max-h-full overflow-x-hidden overflow-y-auto pr-1"
      >
        <TabsList className="justify-around">
          {hasMatch && (
            <>
              <TabsTrigger value="freelancer-pitch">
                Freelancer Pitch
              </TabsTrigger>
              <TabsTrigger value="match-history">Match History</TabsTrigger>
            </>
          )}
          <TabsTrigger value="activity-history">Activity History</TabsTrigger>
          <TabsTrigger value="tags">
            {hasMatch ? "Tags" : "Bullhorn Metadata"}
          </TabsTrigger>
        </TabsList>

        {hasMatch && (
          <>
            <TabsContent value="freelancer-pitch">
              <FreelancerPitch pitch={freelancerPitch} />
            </TabsContent>

            <TabsContent value="match-history">
              <Suspense
                fallback={
                  <SkeletonTables
                    headers={["Old Value", "New Value", "Changed By", "Date"]}
                  />
                }
              >
                <MatchHistory
                  applicationId={applicationId}
                  jobOpportunityId={jobOpportunityId}
                />
              </Suspense>
            </TabsContent>
          </>
        )}

        <TabsContent value="activity-history">
          <Suspense
            fallback={
              <SkeletonTables headers={["Action", "Message", "Date"]} />
            }
          >
            <ActivityHistory userId={id} user={user} />
          </Suspense>
        </TabsContent>

        <TabsContent value="tags">
          {hasMatch ? (
            <Suspense fallback={<SkeletonTables headers={["Key", "Value"]} />}>
              <MatchMetadata
                applicationId={applicationId}
                jobOpportunityId={jobOpportunityId}
              />
            </Suspense>
          ) : (
            <BullhornMetadata type="table" metadata={user.metadata} />
          )}
        </TabsContent>
      </Tabs>
    </AppDialog>
  );
}
